const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.1 42",
    style: {
      enableBackground: "new 0 0 40.1 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M40.1 31.1v-7.4l-.8-.5-19.2 10.5-18.2-10v-4.3l18.2 9.9 20.1-10.9v-7.3l-.8-.5-19.3 10.6-17.5-9.6L20.1 2l14.1 7.7 1.1-.6v-.8L20.1 0 0 10.9V12l20.1 11 18.2-10v4.4l-18.2 10L.8 16.8l-.8.5v7.4l20.1 10.9 18.2-9.9V30L20.1 40 .8 29.5 0 30v1.1L20.1 42l20-10.9z",
    style: {
      fill: "#ff3621"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/databricks.6457a492775421dd2001e20990571e4b.svg";
export { ForwardRef as ReactComponent };